import React from 'react'

import { COACH_APPLY_PATH } from '@/lib/constants/routes'
import { useIsCoach } from '@/hooks/useAuthSession'

import { AppContext } from '@/components/base/appcontext'
import LinkWithState from '@/components/base/link'

import { Typography } from '@/components/ui/typography'

const TABS = [0, 1, 2, 3, 4, 5, 6]
// One tab is already gone, as if someone took it.
const TORN_TAB = 3

// Gym-corkboard "wanted" flyer; the whole flyer opens the coach application.
// Hidden for coaches.
const CoachFlyer: React.FC = () => {
    const appContext = React.useContext(AppContext)
    if (useIsCoach()) return null
    const label = appContext.geti18n('homepage.coachCta.apply')

    return (
        <LinkWithState to={COACH_APPLY_PATH} className="block px-3 pt-3 pb-1">
            <div className="relative -rotate-2 rounded-sm bg-amber-50 text-amber-950 shadow-md shadow-amber-900/15 dark:bg-amber-950 dark:text-amber-50 dark:shadow-black/40">
                <span
                    aria-hidden
                    className="absolute -top-1.5 left-1/2 h-3 w-3 -translate-x-1/2 rounded-full bg-rose-500 shadow-sm"
                />
                <div className="px-4 pt-5 pb-3">
                    <Typography
                        variant="h3"
                        className="font-black uppercase leading-[1.05]"
                    >
                        {appContext.geti18n('homepage.coachCta.flyer.title')}
                    </Typography>
                    <Typography
                        variant="body-sm"
                        className="mt-1 text-amber-900/80 dark:text-amber-100/80"
                    >
                        {appContext.geti18n('homepage.coachCta.subtitle')}
                    </Typography>
                </div>
                <div
                    aria-hidden
                    className="flex divide-x divide-dashed divide-amber-900/30 border-t border-dashed border-amber-900/30 dark:divide-amber-100/30 dark:border-amber-100/30"
                >
                    {TABS.map((i) => (
                        <span
                            key={i}
                            className="flex h-16 flex-1 items-center justify-center text-xs font-semibold"
                        >
                            {i !== TORN_TAB && (
                                <span className="[writing-mode:vertical-rl]">
                                    {label}
                                </span>
                            )}
                        </span>
                    ))}
                </div>
            </div>
        </LinkWithState>
    )
}

export default CoachFlyer
